import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipContentComponent } from './tooltip-content.component';
import { TooltipDirective } from './tooltip.directive';

@NgModule({
  imports: [CommonModule, OverlayModule, PortalModule, A11yModule],
  declarations: [TooltipDirective, TooltipContentComponent],
  exports: [TooltipDirective],
})
export class TooltipModule {}
